import type { FC } from "react";
import { settingsSections } from "../settingsSections.js";
import { useSettingsSectionsPolicy } from "../settingsSectionsPolicy.js";
import { SettingsSectionPage } from "../shared/settingsSection.js";
import { GreenhouseIntegrationSection } from "./greenhouseIntegrationSection.js";
import { SlackIntegrationSection } from "./slackIntegrationSection.js";

export const RecruitingIntegrationSettingsSection: FC = () => {
  const { isSlackOnlyIntegrations } = useSettingsSectionsPolicy();

  return (
    <SettingsSectionPage title={settingsSections.integrations.label}>
      <div className="flex flex-col space-y-4">
        <SlackIntegrationSection />
        {!isSlackOnlyIntegrations && <GreenhouseIntegrationSection />}
      </div>
    </SettingsSectionPage>
  );
};
